import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  gap: 4px;
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const LanguageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NameBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Name = styled.strong`
  ${({ theme }) => css`
    display: block;
    max-width: calc(100% - 36px);
    ${theme.mixins.text.ellipsis_1};
    ${theme.fontStyle.title.section20_bold}
  `}
`;

export const EditButtonBox = styled.div`
  ${({ theme }) => css``}
`;

export const EditButton = styled.button`
  ${({ theme }) => css``}
`;

export const NickNameBox = styled.div`
  display: block;
`;

export const NickName = styled.span`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.content_light_1};
  `}
`;
